import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { TextButton } from 'seagull';
import { useIoContext } from '~/contexts';
export default function ContactSupportButton(props) {
    const { testId, capitalize, hideContactText, bi } = props, rest = _object_without_properties(props, [
        "testId",
        "capitalize",
        "hideContactText",
        "bi"
    ]);
    const { intercomClient } = useIoContext();
    const contactText = capitalize ? 'Contact' : 'contact';
    return /*#__PURE__*/ _jsx(TextButton, _object_spread_props(_object_spread({}, rest), {
        type: "button",
        testId: testId,
        bi: bi,
        onClick: ()=>intercomClient.showNewMessage(),
        children: hideContactText ? 'Support' : "".concat(contactText, " Support")
    }));
}
